var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.decoratedRooftops,"item-text":"name","item-value":"id","label":"Select a Rooftop","disable":false,"append-outer-icon":"mdi-domain","no-data-text":"No Rooftops","persistent-hint":"","hint":"Select a Rooftop"},model:{value:(_vm.rooftop_id),callback:function ($$v) {_vm.rooftop_id=$$v},expression:"rooftop_id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }